import {Filter, FilterAnyLabels, PropertyTypeQueryKey} from "./Filter.config";
import {useQuery} from "@tanstack/react-query";
import {NextRouter} from "next/router";
import {Distances, NumberOfRooms} from "../../enums/enums";
import {enforceArray, extractInitialSelectedValues, sortingOption} from "../../helpers/FilterFunctions";
import {cities} from "../../models/cities";
import {objects} from "../../models/objects";
import {fetchItem} from "../ReactQueries";

export const VermietungCategories = {
	PropertyType: {
		label: "common.propertyType",
		children: Object.values(Filter).filter(
			(filter) => filter.queryKey === PropertyTypeQueryKey
		)
	},
	Ausstatung: {
		label: "common.facilities",
		children: [
			Filter.Pool,
			Filter.Mooring,
			Filter.Internet,
			Filter.SAT_TV,
			Filter.AirCondition,
			Filter.FencedYard,
			Filter.Dishwasher,
			Filter.WashingMachine,
			Filter.Shutters,
			Filter.BBQ_Grill,
			Filter.Pets,
			Filter.Garage
		]
	},
	Lage: {
		label: "common.location",
		children: [
			Filter.ViewCanal,
			Filter.MooringBefore,
			Filter.SouthOrientation,
			Filter.NorthOrientation
		]
	}
};

export const ArtDerUnterkunftItems = (router: NextRouter) => {
	const {data: activePropertyTypes} = useQuery(
		["activePropertyTypes"],
		(): Promise<{ unique_property_type: string }[]> => {
			return fetchItem("property-types", {});
		},
		{initialData: []}
	);

	const propertyTypeItems = Object.values(Filter).filter(
		(filter) => filter.queryKey === PropertyTypeQueryKey
	);

	const activePropertyTypeItems = propertyTypeItems
		.filter((i) =>
			activePropertyTypes
				.map((t) => t.unique_property_type)
				.some((type) => i.values?.includes(type))
		)
		.map((i) => {
			return {
				primaryLabel: i.label,
				id: i.label,
				checked: i.values?.some(
					(v) =>
						router.query[PropertyTypeQueryKey] &&
						enforceArray(router.query[PropertyTypeQueryKey]).includes(v)
				)
					? true
					: false
			};
		});
	return {
		label: VermietungCategories.PropertyType.label,
		items: [
			{
				primaryLabel: FilterAnyLabels.BELIEBIG,
				id: FilterAnyLabels.BELIEBIG,
				checked: !router.query[PropertyTypeQueryKey] ? true : false
			},
			...activePropertyTypeItems
		]
	};
};

export const BadezimmerItems = (router: NextRouter) => {
	return {
		title: Filter.BathroomsTotal.label,
		items: Filter.BathroomsTotal.values,
		singleChoice: true,
		defaultChecked: extractInitialSelectedValues(
			Filter.BathroomsTotal.queryKey,
			router
		) ?? [FilterAnyLabels.BELIEBIG]
	};
};

export const SchlafzimmerItems = (router: NextRouter) => {
	const extractedRouterValue = extractInitialSelectedValues(
		Filter.BedroomsTotal.queryKey,
		router
	);

	const numberOfRoomsValues = Object.values(NumberOfRooms).map(
		(room) => room.value
	);
	const numberOfSelectedRooms = numberOfRoomsValues.find(
		(value) => extractedRouterValue && value.includes(extractedRouterValue[0])
	);

	return {
		title: Filter.BedroomsTotal.label,
		items: Filter.BedroomsTotal.values,
		singleChoice: true,
		defaultChecked: Object.values(NumberOfRooms).find(
			(room) => room.value === numberOfSelectedRooms
		)?.label
			? enforceArray(
				Object.values(NumberOfRooms).find(
					(room) => room.value === numberOfSelectedRooms
				)?.label
			)
			: [FilterAnyLabels.BELIEBIG]
	};
};

export const AusstattungItems = (router: NextRouter, startpage?: boolean) => {
	const startpageItems = {
		label: VermietungCategories.Ausstatung.label,
		items: [
			{
				primaryLabel: Filter.Pool.label,
				id: Filter.Pool.label,
				checked: router.query[Filter.Pool.queryKey] ? true : false
			},
			{
				primaryLabel: Filter.Mooring.label,
				id: Filter.Mooring.label,
				checked: router.query[Filter.Mooring.queryKey] ? true : false
			},
			{
				primaryLabel: Filter.Pets.label,
				id: Filter.Pets.label,
				checked: router.query[Filter.Pets.queryKey] ? true : false
			},
			{
				primaryLabel: Filter.AirCondition.label,
				id: Filter.AirCondition.label,
				checked: router.query[Filter.AirCondition.queryKey] ? true : false
			},
			{
				primaryLabel: Filter.Internet.label,
				id: Filter.Internet.label,
				checked: router.query[Filter.Internet.queryKey] ? true : false
			}
			// {
			//   primaryLabel: Filter.WashingMachine.label,
			//   id: Filter.WashingMachine.label,
			//   checked: router.query[Filter.WashingMachine.queryKey] ? true : false
			// }
		]
	};

	if (startpage) {
		return startpageItems;
	}

	const extendedItems = [
		// {
		//   primaryLabel: Filter.SAT_TV.label,
		//   id: Filter.SAT_TV.label,
		//   checked: router.query[Filter.SAT_TV.queryKey] ? true : false
		// },
		// {
		//   primaryLabel: Filter.FencedYard.label,
		//   id: Filter.FencedYard.label,
		//   checked: router.query[Filter.FencedYard.queryKey] ? true : false
		// },
		// {
		//   primaryLabel: Filter.Dishwasher.label,
		//   id: Filter.Dishwasher.label,
		//   checked: router.query[Filter.Dishwasher.queryKey] ? true : false
		// },
		// {
		//   primaryLabel: Filter.Shutters.label,
		//   id: Filter.Shutters.label,
		//   checked: router.query[Filter.Shutters.queryKey] ? true : false
		// },
		// {
		//   primaryLabel: Filter.BBQ_Grill.label,
		//   id: Filter.BBQ_Grill.label,
		//   checked: router.query[Filter.BBQ_Grill.queryKey] ? true : false
		// },
		// {
		//   primaryLabel: Filter.Garage.label,
		//   id: Filter.Garage.label,
		//   checked: router.query[Filter.Garage.queryKey] === "1" ? true : false
		// }
	];

	const totalItems = {
		...startpageItems,
		items: [
			...startpageItems.items
			// ...extendedItems
		]
	};
	return totalItems;
};

export const DistanceToItems = (
	router: NextRouter,
	filter: {
		label: string;
		queryKey: string;
		values?: string[] | undefined;
	}
) => {
	const {queryKey, label, values} = filter;
	const obj = {
		title: label,
		items: values,
		singleChoice: true
	};

	if (!router.query[queryKey]) {
		return {...obj, defaultChecked: [FilterAnyLabels.BELIEBIG]};
	}

	const queryValue = router.query[queryKey];

	return {
		...obj,
		defaultChecked: enforceArray(
			Object.values(Distances).find(
				(dist) => dist.match_code.toString() == queryValue
			)?.label
		)
	};
};

export const VermietungSortingOptions: sortingOption[] = [
	{
		label: "sortingOptions.relevance"
	},
	{
		label: "sortingOptions.asc",
		queryKey: "as_in_eur_per_week",
		sortDirection: "asc"
	},
	{
		label: "sortingOptions.desc",
		queryKey: "as_in_eur_per_week",
		sortDirection: "desc"
	}
];
